import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  selectionResult: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    overflow: hidden;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
